import { PluginMessages } from './integratedMessages';
import { fetchDisableInternalTracking, trackConsent, disableInternalTracking, getBusinessUnitId, setBusinessUnitId, skipReview, refreshProxyMappingsCache, fetchProxyMappingsEnabled, toggleProxyMappingsEnabled, } from '../api/wordpressApiClient';
import { removeQueryParamFromLocation } from '../utils/queryParams';
import { startActivation, startInstall } from '../utils/contentEmbedInstaller';
const messageMapper = new Map([
    [
        PluginMessages.TrackConsent,
        (message) => {
            trackConsent(message.payload);
        },
    ],
    [
        PluginMessages.InternalTrackingChangeRequest,
        (message, embedder) => {
            disableInternalTracking(message.payload)
                .then(() => {
                embedder.postMessage({
                    key: PluginMessages.InternalTrackingFetchResponse,
                    payload: message.payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.InternalTrackingChangeError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.InternalTrackingFetchRequest,
        (__message, embedder) => {
            fetchDisableInternalTracking()
                .then(({ message: payload }) => {
                embedder.postMessage({
                    key: PluginMessages.InternalTrackingFetchResponse,
                    payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.InternalTrackingFetchError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.BusinessUnitFetchRequest,
        (__message, embedder) => {
            getBusinessUnitId()
                .then(payload => {
                embedder.postMessage({
                    key: PluginMessages.BusinessUnitFetchResponse,
                    payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.BusinessUnitFetchError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.BusinessUnitChangeRequest,
        (message, embedder) => {
            setBusinessUnitId(message.payload)
                .then(payload => {
                embedder.postMessage({
                    key: PluginMessages.BusinessUnitFetchResponse,
                    payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.BusinessUnitChangeError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.SkipReviewRequest,
        (__message, embedder) => {
            skipReview()
                .then(payload => {
                embedder.postMessage({
                    key: PluginMessages.SkipReviewResponse,
                    payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.SkipReviewError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.RemoveParentQueryParam,
        (message) => {
            removeQueryParamFromLocation(message.payload);
        },
    ],
    [
        PluginMessages.ContentEmbedInstallRequest,
        (message, embedder) => {
            startInstall(message.payload.nonce)
                .then(payload => {
                embedder.postMessage({
                    key: PluginMessages.ContentEmbedInstallResponse,
                    payload: payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.ContentEmbedInstallError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.ContentEmbedActivationRequest,
        (message, embedder) => {
            startActivation(message.payload.activateAjaxUrl)
                .then(payload => {
                embedder.postMessage({
                    key: PluginMessages.ContentEmbedActivationResponse,
                    payload: payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.ContentEmbedActivationError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.RefreshProxyMappingsRequest,
        (__message, embedder) => {
            refreshProxyMappingsCache()
                .then(() => {
                embedder.postMessage({
                    key: PluginMessages.RefreshProxyMappingsResponse,
                    payload: {},
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.RefreshProxyMappingsError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.ProxyMappingsEnabledRequest,
        (__message, embedder) => {
            fetchProxyMappingsEnabled()
                .then(payload => {
                embedder.postMessage({
                    key: PluginMessages.ProxyMappingsEnabledResponse,
                    payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.ProxyMappingsEnabledError,
                    payload,
                });
            });
        },
    ],
    [
        PluginMessages.ProxyMappingsEnabledChangeRequest,
        ({ payload }, embedder) => {
            toggleProxyMappingsEnabled(payload)
                .then(() => {
                embedder.postMessage({
                    key: PluginMessages.ProxyMappingsEnabledResponse,
                    payload,
                });
            })
                .catch(payload => {
                embedder.postMessage({
                    key: PluginMessages.ProxyMappingsEnabledChangeError,
                    payload,
                });
            });
        },
    ],
]);
export const messageMiddleware = (embedder) => (message) => {
    const next = messageMapper.get(message.key);
    if (next) {
        next(message, embedder);
    }
};
